/**
 * 25,4 mm per inch when converted
 */
export const MMPERINCH = 25.4;
export const MMPERPIXEL = 0.28;

/**
  * value for high resolution
  */
export const HIGHRES = 90;

/**
  * value for low resolution
  */
export const DEFAULTRES = 90;

/**
  * Width (and height) of tiles for high or low resolution
  */
export const HIGHRESWIDTH = 256;
export const DEFAULTRESWIDTH = 256;

export const paperSizes = [
    {
        name: 'A2 portrait',
        width: 420,
        height: 594
    },
    {
        name: 'A2 landscape',
        width: 594,
        height: 420
    },
    {
        name: 'A3 portrait',
        width: 297,
        height: 420
    },
    {
        name: 'A3 landscape',
        width: 420,
        height: 297
    },
    {
        name: 'A4 portrait',
        width: 210,
        height: 297
    },
    {
        name: 'A4 landscape',
        width: 297,
        height: 210
    },
    {
        name: 'A5 portrait',
        width: 148,
        height: 210
    },
    {
        name: 'A5 landscape',
        width: 210,
        height: 148
    }
];

export const PAPER_FORMATS =
{
    A4_PORTRAIT: 'A4 portrait'
};
